// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__QJYxN","transparent":"tab_transparent__iaeYn","amount":"tab_amount__D0Jop","filled":"tab_filled__r3w5R"};